import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=a7fd3fd6&scoped=true&"
import script from "./detail.vue?vue&type=script&lang=js&"
export * from "./detail.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&lang=css&"
import style1 from "./detail.vue?vue&type=style&index=1&lang=css&"
import style2 from "./detail.vue?vue&type=style&index=2&id=a7fd3fd6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7fd3fd6",
  null
  
)

export default component.exports